import { getCookie, setCookie } from '@utilities/cookies';

export default class GenericBannerPlugin {
  opt: any;
  dom: HTMLElement;

  constructor(dom: HTMLElement, o: any) {
    const defaults = {
      expires: 0,
    };

    this.opt = {
      ...defaults,
      ...o,
    };

    this.dom = dom;
  }

  init() {
    const cookieName = `${this.opt.id}_PromotionHPs`;
    this.dom.classList.toggle('hidden', !!getCookie(cookieName));

    this.dom.querySelector('.js-banner-close')?.addEventListener('click', () => {
      setCookie(cookieName, true, {
        expires: this.opt.expires,
        path: '/',
        domain: location.hostname === 'localhost' ? 'localhost' : '.uefa.com',
      });
      this.dom.classList.add('hidden');
    });
  }
}
